<template>
  <div class="cart-order-fast">
    <div class="cart-order-fast__inner">
      <h2 class="cart-order-fast__title">
        Покупка в 1 клик
      </h2>
      <div class="cart-order-fast__subtitle text text__small">
        Отправьте данные для заказа, в течение 15 минут вам позвонит менеджер для его подтверждения
      </div>
      <ul class="cart-order-fast__fields form-field">
        <li class="cart-order-fast__field">
          <label for="fast_order_name" class="cart-order-fast__label">
            Ваше имя*
          </label>
          <input type="text" id="fast_order_name" class="cart-order-fast__input" v-model="name">
          <ItemErrors :errors="errors.name"/>
        </li>
        <li class="cart-order-block__field">
          <label for="fast_order_phone" class="cart-order-block__label">
            Телефон*
          </label>

          <input
              type="text"
              v-mask="'+7 (###) ###-##-##'"
              :value="displayedPhone"
              @input="handlePhoneInput"
              ref="phone"
              id="fast_order_phone"
              name="phone"
              required="required"
              class="cart-contacts__input required"
          >

          <ItemErrors :errors="errors.phone"/>
        </li>
      </ul>

      <div class="cart-order-fast__button-wrap">
        <div class="cart-order-fast__politic">
          <PolicyCheckbox :id="'152'"
                          v-model="policyCheckbox"
                          :documents="documents"
                          class="_cart-checkbox"
          />

          <NewsCheckbox :id="'38'"
                        v-model="newsCheckbox"
                        :documents="documents"
          />
        </div>

        <button class="cart-order-fast__button button" @click="sendOrder" ref="submit">
          Купить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from "vuex";
import ItemErrors from "./ItemErrors.vue";
import {makeMask} from "../../../js/field/phone";
import PolicyCheckbox from "../parts/common/policy-checkbox.vue";
import NewsCheckbox from "../parts/common/news-checkbox.vue";

export default {
  name: "TheCartOrderFast",
  components: {
    NewsCheckbox, PolicyCheckbox,
    ItemErrors
  },
  mounted() {
    const phoneInput = this.$refs.phone;
    // makeMask(phoneInput);
  },
  computed: {
    ...mapState('order', {
      'name': 'name',
      'phone': 'phone',
      'errors': 'errors',
      'policyCheckbox': 'policyCheckbox',
      'newsCheckbox': 'newsCheckbox'
    }),
    ...mapState('cart', {
      'isCartPromoApply': 'isPromoApply',
      'documents': 'documents'
    }),
    name: {
      get () {
        return this.$store.state.order.name
      },
      set (value) {
        this.$store.commit('order/setName', value)
      }
    },
    phone: {
      get () {
        return this.$store.state.order.phone
      },
      set (value) {
        this.$store.commit('order/setPhone', value)
      }
    },
    policyCheckbox: {
      get() {
        return this.$store.state.order.policyCheckbox;
      },
      set(value) {
        this.$store.commit('order/setPolicyCheckbox', value);
      }
    },
    newsCheckbox: {
      get() {
        return this.$store.state.order.newsCheckbox;
      },
      set(value) {
        this.$store.commit('order/setNewsCheckbox', value);
      }
    },
    displayedPhone() {
      let value = this.phone ? this.phone.toString() : '';
      let digits = value.replace(/\D/g, '');

      // Если начинается с "8", заменяем на "7"
      if (digits.startsWith('8')) {
        digits = '7' + digits.substring(1);
      }

      // Ограничиваем до 11 цифр
      digits = digits.substring(0, 11);

      return digits;
    }
  },
  methods: {
    ...mapActions('order', {
      'send': 'send'
    }),
    ...mapMutations({
      'setIsPromoApply': 'order/setIsPromoApply',
    }),
    handlePhoneInput(event) {
      let input = event.target.value.replace(/\D/g, '');

      // Если начинается с "8", заменяем на "7"
      if (input.startsWith('8')) {
        input = '7' + input.substring(1);
      }

      // Ограничиваем до 11 цифр
      input = input.substring(0, 11);

      // Обновляем значение в store
      this.phone = input;
    },
    sendOrder() {
      if (!this.name || !this.phone) {
        this.send(true);
      } else {
        this.$refs.submit.disabled = true;
        if (this.isCartPromoApply) {
          this.setIsPromoApply(this.isCartPromoApply);
        }
        this.send(true);
      }
    }
  }
}
</script>

<style lang="scss">

</style>